import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CodesaResponseData } from '@core/response/codesa-reponse-data';
import { CodesaResponsePaginable } from '@core/response/codesa-response-paginable';
import { ServiceBase } from '@core/services/service-base';
import { RegistrationPreSorteoGna } from '../../models/registration-pre-sorteo-gna.model';

const service = 'coreService';

@Injectable({
  providedIn: 'root'
})
export class RegistrationPresorteoService extends ServiceBase {

  constructor(
    private http: HttpClient
  ) {
    super(service);
  }

  getRegistrations(): Promise<CodesaResponsePaginable<RegistrationPreSorteoGna>> {
    return this.http.get<CodesaResponsePaginable<RegistrationPreSorteoGna>>
    (`${this.url}/admin/registration-presorteo-gna/get-all`).toPromise();
  }

  createRegistration(request: {codeLottery: string, dateGameLottery: string}): Promise<CodesaResponseData<RegistrationPreSorteoGna>> {
    return this.http.post<CodesaResponseData<RegistrationPreSorteoGna>>
    (`${this.url}/admin/registration-presorteo-gna/create`, request).toPromise();
  }
}
